class MyButtonMenu {
  constructor(vueInstance) {
    this.vueInstance = vueInstance;
    this.title = "重新生成"; // 自定义菜单标题
    // this.iconSvg = `<svg t="1709718547819" class="icon" viewBox="0 0 1024 1024"
    // version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2435" width="200"
    // height="200"><path d="M960 416V192l-73.056 73.056a447.712
    // 447.712 0 0 0-373.6-201.088C265.92 63.968 65.312 264.544 65.312
    // 512S265.92 960.032 513.344 960.032a448.064 448.064 0 0 0
    // 415.232-279.488 38.368 38.368 0 1 0-71.136-28.896 371.36 371.36
    // 0 0 1-344.096 231.584C308.32 883.232 142.112 717.024 142.112 512S308.32
    // 140.768 513.344 140.768c132.448 0 251.936 70.08 318.016 179.84L736 416h224z"
    // p-id="2436"></path></svg>`; // 可选 菜单图标
    this.tag = "button";
  }
  // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
  getValue() {
    // JS 语法
  }
  // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
  isActive() {
    // JS 语法
    return false;
  }
  // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
  isDisabled() {
    // JS 语法
    return false;
  }
  // 点击菜单时触发的函数
  exec(editor) {
    // JS 语法
    // that.handleClickRegeneration();
    editor.emit("regenerationClick");
  }
}

const regeneration = {
  key: "regeneration", // 定义 menu key ：要保证唯一、不重复（重要）
  factory() {
    return new MyButtonMenu();
  },
};

export default regeneration;
